import { cn } from '@sohanemon/utils';
import type { ComponentProps } from 'react';

import { ThemedLottie } from './themed-lottie';

const ASTRONAUT_ROCKET_COLOR_SLOTS = {
	'astronaut-ink': '--foreground',
	'astronaut-primary': '--primary',
	'astronaut-white': '--card',
	'astronaut-accent': '--accent',
};

type AstronautRocketLottieProps = ComponentProps<typeof ThemedLottie>;

export function AstronautRocketLottie(props: AstronautRocketLottieProps) {
	const { autoplay = true, loop = true, className, style, ...rest } = props;

	return (
		<ThemedLottie
			src="/lottie/astronaut-grabbing-rocket.lottie"
			loop={loop}
			autoplay={autoplay}
			colorSlotTokens={ASTRONAUT_ROCKET_COLOR_SLOTS}
			className={cn('mx-auto aspect-square w-full max-w-xl', className)}
			style={style}
			{...rest}
		/>
	);
}
